import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import EditNoteIcon from '@mui/icons-material/EditNote';
import PublishIcon from '@mui/icons-material/Publish';
import VerifiedIcon from '@mui/icons-material/Verified';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import ArchiveIcon from '@mui/icons-material/Archive';
import PendingActionsIcon from '@mui/icons-material/PendingActions';

const ContentTabs = ({ value, onChange }) => {
  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
      <Tabs value={value} onChange={onChange} aria-label="practice collection tabs" variant="scrollable" scrollButtons="auto">
        <Tab icon={<PendingActionsIcon />} label="In Progress" iconPosition="start" />
        <Tab icon={<EditNoteIcon />} label="Drafts" iconPosition="start" />
        <Tab icon={<PublishIcon />} label="Published" iconPosition="start" />
        <Tab icon={<VerifiedIcon />} label="Approved" iconPosition="start" />
        <Tab icon={<RocketLaunchIcon />} label="Released" iconPosition="start" />
        <Tab icon={<ArchiveIcon />} label="Archived" iconPosition="start" />
      </Tabs>
    </Box>
  );
};

export default ContentTabs;
